module.exports = __webpack_public_path__ + "img/hairs.81b459c6.svg";